<template>
  <b-overlay :show="loading">
    <b-card
      title="جزئیات رژیم"
    >
      <b-row align-h="center">
        <b-col
          lg="10"
          md="12"
        >
          <b-row>
            <b-col md="3">
              <b-form-group
                label="عنوان"
              >
                <b-form-input
                  id="Title"
                  v-model="form.Title"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="کالری"
              >
                <dedicated-diet-calories
                  v-model="form.SpecialDietCalorieId"
                  :multiple="false"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="مکمل"
              >
                <dedicated-diet-supplement
                  v-model="form.SupplementIds"
                  :multiple="true"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="توصیه"
              >
                <dedicated-diet-recommendations
                  v-model="form.RecommendIds"
                  :multiple="true"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group
                  label="واحد لبنیات در روز"
              >
                <b-form-input
                    id="Dairy"
                    v-model="form.Dairy"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="تعداد روز پیاده روی در هفته"
              >
                <b-form-input
                    id="SportDays"
                    v-model="form.SportDays"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="زمان پیاده روی در روز"
              >
                <b-form-input
                    id="SportMinute"
                    v-model="form.SportMinute"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="تعداد روز ورزش در هفته"
              >
                <b-form-input
                    id="SportCalorie"
                    v-model="form.SportCalorie"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="بادام"
              >
                <b-form-input
                    id="Almond"
                    v-model="form.Almond"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="آب"
              >
                <b-form-input
                    id="Water"
                    v-model="form.Water"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="چای"
              >
                <b-form-input
                    id="Tea"
                    v-model="form.Tea"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="قند"
              >
                <b-form-input
                    id="SugarLoaf"
                    v-model="form.SugarLoaf"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                  label="شکر"
              >
                <b-form-input
                    id="Sugar"
                    v-model="form.Sugar"
                    autocomplete="off"
                    type="number"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-card
            v-for="(meal,index) in form.SpecialDietFoodMeal"
            border-variant="dark"
            class="position-relative"
          >
            <trash
              v-model="form.SpecialDietFoodMeal"
              :index="index"
              style="position:absolute;top: 2px;left:2px"
            />
            <b-row>
              <b-col md="3">
                <b-form-group
                  label="وعده"
                >
                  <z-food-meal
                    v-model="meal.FoodMealId"
                    :multiple="false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="زمان صرف غذا"
                >
                  <b-form-input v-model="meal.EatTime" />
                </b-form-group>
              </b-col>
              <b-col md="1">
                <b-form-group
                    label="ترتیب وعده"
                >
                  <b-form-input v-model="meal.Sort" type="number" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="توضیحات"
                >
                  <b-form-textarea v-model="meal.Description" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-for="(item, specialDietFoodMealListIndex) in meal.SpecialDietFoodMealList">
              <b-col md="12">
                <hr>
              </b-col>
              <b-col md="1">
                <b-form-group
                    label="ترتیب"
                >
                  <b-form-input v-model="item.Sort" type="number" />
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group
                  label="لیست غذایی"
                >
                  <dedicated-diet-list-food
                    v-model="item.SpecialDietFoodListId"
                    :multiple="false"
                    @selected="foods(item, $event)"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-for="food in item.SpecialDietFoodMealListRowDetails"
                md="3"
              >
                <b-form-group
                  :label="`${getFoodAndFoodUntTitle(food.SpecialDietFoodListRowDetailsId)}`"
                >
                  <b-form-input v-if="showAmount(food.SpecialDietFoodListRowDetailsId)" v-model="food.Amount" />
                  <b-form-input v-else readonly :value="food.Description" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                    label="توضیحات"
                >
                  <b-form-input v-model="item.Description" />
                </b-form-group>
              </b-col>
              <b-col md="10">
                <b-form-group>
                  <b-form-checkbox
                      v-model="item.OnlyOnceAtWeek"
                      name="OnlyOnceAtWeek"
                      value="true"
                      class="custom-control-success"
                  >
                    این لیست غذایی فقط یکبار در هفته استفاده شود.
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col
                align-self="end"
                class="text-right"
              >
                <trash
                  v-model="meal.SpecialDietFoodMealList"
                  :index="specialDietFoodMealListIndex"
                  class="mb-1"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <feather-icon
                  class="btn-icon btn-outline-info cursor-pointer"
                  icon="PlusIcon"
                  size="24"
                  @click="meal.SpecialDietFoodMealList.push({
                    SpecialDietFoodListId:null,
                    Sort: 0,
                    SpecialDietFoodMealListRowDetails:[]})"
                />
              </b-col>
            </b-row>
          </b-card>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="gradient-info"
            class="mb-1"
            @click="addSpecialDietFoodMeal()"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-25"
            />
            <span>افزودن</span>
          </b-button>
          <b-row>
            <b-col class="text-right">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="save"
              >
                ذخیره
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                @click="back"
              >
                بازگشت
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import DedicatedDietCalories from '@/tools/dedicatedDietCalories'
import DedicatedDietSupplement from '@/tools/dedicatedDietSupplement'
import DedicatedDietRecommendations from '@/tools/dedicatedDietRecommendations'
import DedicatedDietListFood from '@/tools/dedicatedDietListFood'
import ZFoodMeal from '@/tools/foodmeal.vue'
import trash from '@/tools/trash.vue'
import { mapState } from 'vuex'

export default {
  name: 'AddDedicatedDietRegime',
  components: {
    DedicatedDietRecommendations, DedicatedDietSupplement, DedicatedDietCalories, ZFoodMeal, DedicatedDietListFood, trash,
  },
  data() {
    return {
      form: {
        Id: null,
        Title: null,
        SpecialDietCalorieId: null,
        SupplementIds: [],
        RecommendIds: [],
        SpecialDietFoodMeal: [
          {
            FoodMealId: null,
            EatTime: null,
            Description: null,
            Sort: 0,
            SpecialDietFoodMealList: [
              {
                SpecialDietFoodListId: null,
                Sort: 0,
                SpecialDietFoodMealListRowDetails: [],
              },
            ],
          },
        ],
      },
      saveUrl: null,
      loading: false,
    }
  },
  created() {
    if (this.$route.params.clone) {
      // clone
      this.form.Id = this.$route.params.regimeId
      this.saveUrl = this.$api.dedicatedDietList.add
      this.get()
    } else if (this.$route.params.regimeId) {
      // edit
      this.saveUrl = this.$api.dedicatedDietList.update
      this.form.Id = this.$route.params.regimeId
      this.get()
    } else {
      // add
      this.saveUrl = this.$api.dedicatedDietList.add
    }
  },
  computed: {
    ...mapState('zirehState', { foodList: state => state.specialDietFoodListSelect }),
    getFoodAndFoodUntTitle() {
      return id => {
        let title = ''
        if (this.foodList && this.foodList.length) {
          const specialDietFoodListRowDetails = this.foodList.flatMap(x => x.SpecialDietFoodListRowDetails).filter(x => x.Id === id)[0]
          title = specialDietFoodListRowDetails.Food.Title

          if (specialDietFoodListRowDetails.FoodUnit){
            title += ' / ' + specialDietFoodListRowDetails.FoodUnit.Title
          }
        }

        return title
      }
    },
    showAmount() {
      return id => {
        if (this.foodList && this.foodList.length) {
          const specialDietFoodListRowDetails = this.foodList.flatMap(x => x.SpecialDietFoodListRowDetails).filter(x => x.Id === id)[0]
          return specialDietFoodListRowDetails.FoodUnit != null
        }
        return false
      }
    },
  },
  methods: {
    foods(item, listDiet) {
      item.SpecialDietFoodMealListRowDetails = []
      this.foodList.filter(x => x.Id === listDiet.Id)[0].SpecialDietFoodListRowDetails.forEach(food => {
        item.SpecialDietFoodMealListRowDetails.push({
          SpecialDietFoodListRowDetailsId: food.Id,
          Amount: null,
          Description: food.Description
        })
      })
    },
    addSpecialDietFoodMeal() {
      this.form.SpecialDietFoodMeal.push(
        {
          FoodMealId: null,
          EatTime: null,
          Description: null,
          SpecialDietFoodMealList: [],
          Sort: 0,
        },
      )
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.dedicatedDietList.get, {
          Id: this.form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.form = res.data
        })
    },
    save() {
      this.loading = true
      this.$http.post(this.saveUrl, this.form)
        .then(() => {
          this.back()
        }).finally(() => { this.loading = false })
    },
  },
}
</script>

<style scoped>

</style>
